/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';
import type { FindFeaturedParams, Featured } from 'types';

const find = async (params: FindFeaturedParams): Promise<Featured[]> => {
  const endpoint = 'roomitems/findAll';
  const response = await callApiEndpoint(endpoint, { method: 'POST', body: {} });
  // ignoro dati aggiuntivi della risposta e prendo il primo elemento di un array (con un unico elemento)
  const results = response.map(utils.toFeatured);
  return results;
};

const get = async (id: number): Promise<Featured> => {
  let pathUrl = id || 0;
  const endpoint = 'roomitems/' + pathUrl + '/get';
  const response = await callApiEndpoint(endpoint, { params: {} });
  return utils.toFeatured(response);
};

export default {
  find,
  get,
};
